
<ng-container *ngIf="isSmallScreen; else largeScreen">
  <div class="row h-100">
    <div class="col-lg-8 col-sm-12 pt-2">
      <dx-data-grid
        id="gridContainer"
        [dataSource]="MSvc.dataSource" [showBorders]="true" [remoteOperations]="true"
        [focusedRowEnabled]="true" [rowAlternationEnabled]="true"
        height="400"
        dataRowTemplate="dataRowTemplateName"
      >
        <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

        <dxi-column dataField="Name" [caption]="'name' | translateWithFallback" dataType="string"></dxi-column>
        <dxi-column dataField="Kind" [caption]="'kind' | translateWithFallback" dataType="string"></dxi-column>
        <dxi-column dataField="Size" [caption]="'size' | translateWithFallback" dataType="number"></dxi-column>
        <dxi-column dataField="LastWrite" [caption]="'last-write' | translateWithFallback" dataType="date" format="dd/MM/yyyy hh.mm.ss">
        </dxi-column>

        <tr *dxTemplate="let medium of 'dataRowTemplateName'" role="row" [ngClass]="{ 'dx-row-alt': medium.rowIndex % 2 === 0 }">
          <td colspan="8">
            <table width="100%" (click)="onFocusedRowChanged(medium.data)">
              <tr class="main-row" role="row">
                <td role="gridcell" width="10%">
                  <dx-button stylingMode="text" (click)="show(medium.rowIndex + '-medium')">
                    <fa-icon *ngIf="!isShowed[medium.rowIndex + '-medium']" [icon]="faAngleRight"></fa-icon>
                    <fa-icon *ngIf="isShowed[medium.rowIndex + '-medium']" [icon]="faAngleDown"></fa-icon>
                  </dx-button>
                </td>

                <td role="gridcell" width="30%">{{ medium.data.Kind }}</td>
                <td role="gridcell" width="30%">{{ medium.data.Name }}</td>
                <td role="gridcell" width="30%">{{ medium.data.Size }}</td>
              </tr>
              <tr *ngIf="isShowed[medium.rowIndex + '-medium']">
                <td colspan="4">
                  <table width="100%">
                    <tr class="main-row" role="row">
                      <td role="gridcell" colspan="2">{{ medium.data.Kind }}</td>
                      <td role="gridcell" colspan="2">{{ medium.data.Name }}</td>
                    </tr>
                    <tr class="notes-row" role="row">
                      <td role="gridcell" colspan="2">{{ medium.data.Size }}</td>
                      <td role="gridcell" colspan="2">{{ medium.data.LastWrite }}</td>
                    </tr>
                    <tr class="notes-row" role="row">
                      <td role="gridcell" colspan="4">{{ medium.data.Description }}</td>
                    </tr>
                    <tr class="notes-row" role="row">
                      <td role="gridcell" colspan="4">
                        <dx-button stylingMode="outlined" icon="trash" (onClick)="delete(medium.data)" [VisibleForRoles]="['SUPERADMIN']">
                        </dx-button>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-paging [pageSize]="25"> </dxo-paging>
        <dxo-pager [visible]="true" [showInfo]="true"
          [showNavigationButtons]="true"
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 25, 50, 100]">
        </dxo-pager>
      </dx-data-grid>
    </div>

    <div class="col-lg-4 col-sm-12 p-2">
      <dx-data-grid height="200" [dataSource]="verDataSource" [showBorders]="true" [remoteOperations]="true"
        [rowAlternationEnabled]="true" [repaintChangesOnly]="true"
        (onRowPrepared)="OnRowPrepared($event)"
        id="gridContainer"
        dataRowTemplate="dataRowTemplateName">

        <dxi-column dataField="Version" [caption]="'ver' | translateWithFallback" dataType="number" sortOrder="desc" width="25%"></dxi-column>
        <dxi-column dataField="FenixVersion"[caption]="'fenix-version' | translateWithFallback"  dataType="string" width="25%"></dxi-column>
        <dxi-column dataField="Size" [caption]="'size' | translateWithFallback" dataType="number" width="25%"></dxi-column>
        <dxi-column dataField="LastWrite" [caption]="'last-write' | translateWithFallback" dataType="date" format="dd/MM/yyyy hh.mm.ss" width="25%"></dxi-column>

        <dxo-load-panel [enabled]="MSvc.loadingVer"></dxo-load-panel>

        <tr *dxTemplate="let mediumVer of 'dataRowTemplateName'" role="row" [ngClass]="{ 'dx-row-alt': mediumVer.rowIndex % 2 === 0 }">
          <td colspan="4">
            <table width="100%" >
              <tr class="main-row" role="row">
                <td role="gridcell" width="10%">
                  <dx-button stylingMode="text" (click)="show(mediumVer.rowIndex + '-version')">
                    <fa-icon *ngIf="!isShowed[mediumVer.rowIndex + '-version']" [icon]="faAngleRight"></fa-icon>
                    <fa-icon *ngIf="isShowed[mediumVer.rowIndex + '-version']" [icon]="faAngleDown"></fa-icon>
                  </dx-button>
                </td>
                <td role="gridcell" width="45%">{{ mediumVer.data.Version }}</td>
                <td role="gridcell" width="45%">{{ mediumVer.data.Size }}</td>
              </tr>
              <tr *ngIf="isShowed[mediumVer.rowIndex + '-version']">
                <td colspan="3">
                  <table width="100%">
                    <tr class="main-row" role="row">
                      <td role="gridcell">{{ mediumVer.data.Version }}</td>
                      <td role="gridcell">{{ mediumVer.data.FenixVersion }}</td>
                    </tr>
                    <tr class="notes-row" role="row">
                      <td role="gridcell">{{ mediumVer.data.Size }}</td>
                      <td role="gridcell">{{ mediumVer.data.LastWrite }}</td>
                    </tr>
                    <tr class="notes-row" role="row">
                      <td role="gridcell" colspan="2">{{ mediumVer.data.Description }}</td>
                    </tr>
                    <tr class="notes-row" role="row">
                      <td role="gridcell" colspan="2">
                        <dx-button [hint]="'download' | translateWithFallback" title="Download" stylingMode="outlined" class="w-100 mt-2 mr-2" (click)="download(mediumVer.data)">
                          <span class="button-content">
                            <fa-icon *ngIf="!downloadLoading" [icon]="faDownload"></fa-icon>
                            <dx-load-indicator
                              [(visible)]="downloadLoading"
                              [height]="18"
                              [width]="18">
                            </dx-load-indicator>
                            <span class="pl-2">{{ 'download' | translateWithFallback }}</span>
                          </span>
                        </dx-button>

                        <dx-button 
                          *ngIf="mediumVer.data.Version != actualVersion"
                          stylingMode="outlined"
                          class="w-100 mt-2 mr-2"
                          text="Checkout"
                          [hint]="'checkout' | translateWithFallback"
                          [ngClass]="{'actual-version': mediumVer.data.Version == actualVersion}" 
                          (onClick)="checkout(mediumVer.data)"
                          >
                        </dx-button>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <dxo-sorting mode="multiple"></dxo-sorting>

      </dx-data-grid>
    </div>
  </div>
</ng-container>

<ng-template #largeScreen>
  <div class="row h-100 m-0 p-0">
    <div class="col-lg-8 col-sm-12 pt-2">
      <dx-data-grid id="gridContainer" class="medium-table" [dataSource]="MSvc.dataSource" [showBorders]="true" [remoteOperations]="true"
        [focusedRowEnabled]="true" [rowAlternationEnabled]="true" (onFocusedRowChanged)="onFocusedRowChanged($event)"
        [columnHidingEnabled]="true">
        <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

        <dxi-column dataField="Kind" [caption]="'kind' | translateWithFallback" dataType="string"> </dxi-column>
        <dxi-column dataField="Name" [caption]="'name' | translateWithFallback" dataType="string"> </dxi-column>
        <dxi-column dataField="Description"[caption]="'description' | translateWithFallback" dataType="string" [hidingPriority]="1"> </dxi-column>
        <dxi-column dataField="Size" [caption]="'size' | translateWithFallback" dataType="number" [hidingPriority]="0"> </dxi-column>
        <dxi-column dataField="LastWrite" [caption]="'last-write' | translateWithFallback" dataType="date" format="dd/MM/yyyy hh.mm.ss" [hidingPriority]="2">
        </dxi-column>

        <dxi-column cellTemplate="buttonCellTemplate" [hidingPriority]="3"></dxi-column>
        <div *dxTemplate="let data of 'buttonCellTemplate'">
          <dx-button stylingMode="outlined" icon="trash" (onClick)="delete(data.data)" [VisibleForRoles]="['SUPERADMIN']">
          </dx-button>
        </div>

        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-scrolling rowRenderingMode="virtual"> </dxo-scrolling>
        <dxo-paging [pageSize]="25"> </dxo-paging>
        <dxo-pager [visible]="true" [showInfo]="true" [showNavigationButtons]="true" [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 25, 50, 100]">
        </dxo-pager>
      </dx-data-grid>
    </div>
    <div class="col-lg-4 col-sm-12 p-2">
      <dx-data-grid class="h-100 version-table" [dataSource]="verDataSource" [showBorders]="true" [remoteOperations]="true"
        [rowAlternationEnabled]="true" [columnHidingEnabled]="true" [repaintChangesOnly]="true"
        (onRowPrepared)="OnRowPrepared($event)">

        <dxi-column dataField="Version" [caption]="'ver' | translateWithFallback" dataType="number" sortOrder="desc"> </dxi-column>
        <dxi-column dataField="Description" [caption]="'description' | translateWithFallback" dataType="string" [hidingPriority]="1"> </dxi-column>
        <dxi-column dataField="FenixVersion"[caption]="'fenix-version' | translateWithFallback"  dataType="string" [hidingPriority]="2"> </dxi-column>
        <dxi-column dataField="Size" [caption]="'size' | translateWithFallback" dataType="number" [hidingPriority]="0"> </dxi-column>
        <dxi-column dataField="LastWrite" [caption]="'last-write' | translateWithFallback" dataType="date" format="dd/MM/yyyy hh.mm.ss" [hidingPriority]="2"></dxi-column>

        <dxo-load-panel [enabled]="MSvc.loadingVer"></dxo-load-panel>
        <dxi-column cellTemplate="buttonCellTemplate" [hidingPriority]="1"></dxi-column>
        <div *dxTemplate="let data of 'buttonCellTemplate'">
          <dx-button [hint]="'download' | translateWithFallback" title="Download" stylingMode="outlined" (click)="download(data.data)">
            <span class="button-content">
              <fa-icon *ngIf="!downloadLoading" [icon]="faDownload"></fa-icon>
              <dx-load-indicator
                [(visible)]="downloadLoading"
                [height]="18"
                [width]="18">
              </dx-load-indicator>
              <span class="pl-2">{{ 'download' | translateWithFallback }}</span>
            </span>
          </dx-button>

          <dx-button stylingMode="outlined" [hint]="'checkout' | translateWithFallback" text="Checkout" (onClick)="checkout(data.data)"
            [ngClass]="{'actual-version': data.data.Version == actualVersion}" *ngIf="data.data.Version != actualVersion">
          </dx-button>
        </div>

        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-scrolling rowRenderingMode="virtual"> </dxo-scrolling>

      </dx-data-grid>
    </div>
  </div>
</ng-template>
